/* eslint-disable @typescript-eslint/no-explicit-any */
import { Theme } from '@emotion/react';
import styled from '@emotion/styled';
import { InputLabel } from '@mui/material';

export const CustomSelectStyle = (
  theme: Theme,
  styles?: React.CSSProperties,
  withInput?: boolean,
) => ({
  control: (provided: any, state: any) => {
    const isDisabled = state.isDisabled;
    return {
      ...provided,
      height: '55.99px',
      width: '100%',
      borderRadius: '10px',
      paddingLeft: '3px',
      boxShadow: 'unset !important',
      borderColor: theme.palette?.brand?.gray[300],
      backgroundColor: isDisabled
        ? theme.palette?.grey?.[300]
        : theme.palette?.common?.white,
      backgroundImage: 'none !important',
      '&:hover':
        !withInput && !isDisabled
          ? {
              outline: 'unset !important',
              boxShadow: 'unset !important',
              borderWidth: '1px',
              borderColor: theme.palette?.brand?.primary.base,
            }
          : {},
      ...(styles ?? {}),
    };
  },
  menu: (provided: any) => ({
    ...provided,
    zIndex: 99999,
  }),
  menuList: (provided: any) => ({
    ...provided,
    zIndex: 99999,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? theme.palette?.brand?.primary.base
      : 'white',
    fontWeight: state.isSelected ? 600 : 400,
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: 'rgba(0, 0, 0, 0.15)',
    fontSize: '14px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorContainer: (provided: any) => ({
    ...provided,
    color: theme.palette?.brand?.primary.base,
  }),
});

export const CustomSelectContainer = styled.div<{
  withInput?: boolean;
}>`
  width: 100%;
  height: 100%;
  
  .MuiInputBase-root {
    width: 100%;
    color: ${({ theme }) => theme.palette?.brand?.primary.base};

    :disabled{
       color: ${({ theme }) => theme.palette?.brand?.gray[300]};
    }
    
    .Mui-focused .MuiOutlinedInput-notchedOutline {
      border: 2px solid;
      border-color: ${({ theme }) => theme.palette?.brand?.gray[300]};
    }
    
    fieldset {
      border: 2px solid;
      border-color: ${({ theme }) => theme.palette?.brand?.gray[300]};
      border-radius: 10px;
    }
  }

  .MuiInputBase-root:hover {
    fieldset {
      border-color: ${({ theme }) => theme.palette?.brand?.gray[300]};
    }
  }

  .MuiInputBase-root:focus-within {
    fieldset {
      border-color: ${({ theme }) => theme.palette?.brand?.primary.base};
    }
  }

  
`;

export const InputLabelContainer = styled(InputLabel)`
  color: ${({ theme }) => theme.palette?.brand?.secondary.base};
  font-weight: 600;
  font-size: 14px;
  font-family: 'Inter';
`;

export const TextFieldArea = styled.div<{
  hasLabel?: boolean;
  disabled?: boolean;
}>`
  margin-top: ${({ hasLabel }) => (hasLabel ? '10px' : '0px')};
  background-color: ${({ disabled, theme }) =>
    disabled ? theme.palette?.grey?.[200] : theme.palette?.common?.white};
  border-radius: 10px;
  position: relative;

  input {
    &::placeholder{
      font-weight: 500;
      font-size: 14px;
      font-family: 'Inter';
      color: #C3C1CA;
    }
  }
`;
